import type { PreviewMarqueeItem } from "./preview-copy.types";
const featureMark = {
  hare: { icon: "/home/icon-hare.svg", w: 19, h: 14 },
  run: { icon: "/home/icon-figure-run.svg", w: 13, h: 17 },
  trophy: { icon: "/home/icon-trophy.svg", w: 15, h: 16 },
  track: { icon: "/home/icon-figure-track-and-field.svg", w: 15, h: 20 },
  people: { icon: "/home/icon-person-3.svg", w: 21, h: 11 },
  minus: { icon: "/home/icon-minus.svg", w: 14, h: 14 },
} as const;
type Mark = keyof typeof featureMark;
export function item({
  mark,
  label,
}: {
  mark: Mark;
  label: string;
}): PreviewMarqueeItem {
  return { ...featureMark[mark], label };
}
